import { render, staticRenderFns } from "./Automobile.vue?vue&type=template&id=946b2f6e"
import script from "./Automobile.vue?vue&type=script&lang=ts"
export * from "./Automobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports